export enum PropertyTypeEnum {
  Casa = 1001,
  Apartamento = 1002,
  Empresa = 1099,
};
